module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/delete-user-725b02ad1391ea32510c1d6381c28004.svg";